import React, { useEffect, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Grid,
  Typography
} from "@material-ui/core";
import axios from "axios";
import config from "./config";

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default
    },
    margin: "1rem auto"
  }
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 400
  }
});

const formatDate = dateStr => {
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString("de-AT", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" });
};

const formatOrderTime = id => {
  const timestamp = parseInt(id.substring(0, 8), 16) * 1000;
  const d = new Date(timestamp);
  return d.toLocaleTimeString("de-AT", { hour: "2-digit", minute: "2-digit" });
};

const calculateTotal = object => {
  return Object.keys(object)
    .reduce((acc, value) => acc + object[value]["price"], 0)
    .toFixed(2);
};

const Orders = props => {
  const classes = useStyles();
  const [orders, setOrders] = useState([]);

  const { history, match } = props;
  const routeParams = match.params;

  /**
   * Load all data.
   */
  useEffect(() => {
    (async () => {
      if (routeParams.key) {
        try {
          let response = null;
          response = await axios.get(
            `${config.apiBaseUrl}/api/get-orders?key=${routeParams.key}`
          );
          setOrders(response.data.reverse());
        } catch (err) {
          history.push("/");
        }
      }
    })();
  }, [history, routeParams]);

  const getOrderItems = object => {
    return (
      <StyledTableCell style={{ maxWidth: "150px", wordWrap: "break-word" }}>
        <ul style={{ margin: 0, paddingLeft: "1.2em" }}>
          {Object.keys(object).map(row => (
            <li key={row}>
              {object[row]["title"]} — {object[row]["unit"]} — {object[row]["price"]}€
            </li>
          ))}
        </ul>
      </StyledTableCell>
    );
  };

  return (
    <Grid container spacing={6} display="flex" justify="center">
      <Grid item xs={10}>
        <Typography variant="h4" color="inherit">
          Orders
        </Typography>
      </Grid>
      <Grid item xs={10}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Datum</StyledTableCell>
                <StyledTableCell>Name / Kontakt</StyledTableCell>
                <StyledTableCell>Bemerkungen</StyledTableCell>
                <StyledTableCell>Total</StyledTableCell>
                <StyledTableCell>Produkte</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map(row => (
                <StyledTableRow key={row["_id"]}>
                  <StyledTableCell component="th" scope="row">
                    {formatDate(row.date)}<br/><small>Bestellt um {formatOrderTime(row["_id"])} Uhr</small>
                  </StyledTableCell>
                  <StyledTableCell style={{ maxWidth: "100px", wordWrap: "break-word" }}>
                    {row.vorname} {row.nachname}<br/>
                    <small>{row.email}<br/>{row.telefonnummer}<br/>{row.adresse}</small>
                  </StyledTableCell>
                  <StyledTableCell style={{ maxWidth: "150px", wordWrap: "break-word" }}>{row.bemerkungen}</StyledTableCell>
                  <StyledTableCell>
                    {calculateTotal(JSON.parse(row.order))}€
                  </StyledTableCell>
                  {getOrderItems(JSON.parse(row.order))}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
export default Orders;
